import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-report-footer',
    templateUrl: './report-footer.component.html',
    styleUrls: ['./report-footer.component.css'],
    standalone: false
})
export class ReportFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
